"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSize = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
exports.TextSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize16,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize18,
    _a);
